
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { mockReferrals } from "@/data/mockCustomerData";

interface CustomerReferralsTabProps {
  customerId: string;
}

export function CustomerReferralsTab({ customerId }: CustomerReferralsTabProps) {
  const referrals = mockReferrals.filter(ref => ref.referrerId === customerId);
  
  // Calculate total rewards
  const totalRewards = referrals.reduce((total, ref) => {
    const value = parseFloat(ref.reward.replace('R$ ', '').replace('.', '').replace(',', '.'));
    return total + value;
  }, 0);

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Resumo de Indicações</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="p-4 rounded-lg border bg-muted/20">
              <div className="text-sm font-medium text-gray-500">Total de Indicações</div>
              <div className="text-2xl font-bold">{referrals.length}</div>
            </div>
            <div className="p-4 rounded-lg border bg-muted/20">
              <div className="text-sm font-medium text-gray-500">Indicações Ativas</div>
              <div className="text-2xl font-bold">
                {referrals.filter(ref => ref.status === 'Ativo').length}
              </div>
            </div>
            <div className="p-4 rounded-lg border bg-muted/20">
              <div className="text-sm font-medium text-gray-500">Total de Recompensas</div>
              <div className="text-2xl font-bold">R$ {totalRewards.toFixed(2).replace('.', ',')}</div>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Clientes Indicados</CardTitle>
        </CardHeader>
        <CardContent>
          {referrals.length === 0 ? (
            <div className="text-center py-8 text-gray-500">
              Este cliente ainda não fez indicações.
            </div>
          ) : (
            <div className="rounded-md border">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Cliente</TableHead>
                    <TableHead>Data</TableHead>
                    <TableHead>Status</TableHead>
                    <TableHead>Compras</TableHead>
                    <TableHead>Recompensa</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {referrals.map((ref) => (
                    <TableRow key={ref.id}>
                      <TableCell className="font-medium">{ref.referred}</TableCell>
                      <TableCell>
                        {new Date(ref.date).toLocaleDateString('pt-BR')}
                      </TableCell>
                      <TableCell>
                        <div className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${ref.status === 'Ativo' ? 'bg-green-100 text-green-800' : 'bg-amber-100 text-amber-800'}`}>
                          {ref.status}
                        </div>
                      </TableCell>
                      <TableCell>{ref.purchases}</TableCell>
                      <TableCell>{ref.reward}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
